import { JobsiteWorkerDocumentUpload } from './JobsiteWorkerDocumentUpload';

const name = 'JobsiteWorkerDocumentUpload';

export { JobsiteWorkerDocumentUpload, name };
